import { render, staticRenderFns } from "./Create-Or-Update-Warranty.vue?vue&type=template&id=145b655c&scoped=true"
import script from "./Create-Or-Update-Warranty.vue?vue&type=script&lang=js"
export * from "./Create-Or-Update-Warranty.vue?vue&type=script&lang=js"
import style0 from "./Create-Or-Update-Warranty.vue?vue&type=style&index=0&id=145b655c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145b655c",
  null
  
)

export default component.exports